export default "__VITE_ASSET__Bduwg34L__";